import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';
import FormTextInput from 'components/FormTextInput/TypedFormTextInput';

import { type AppleConfig } from './types';

type AppleNativeConfigCardProps = {
  config: AppleConfig;
  label: string;
  classes: { [key: string]: string };
  onChange: (config: AppleConfig) => void;
};

const AppleNativeConfigCard = ({
  config,
  label,
  classes,
  onChange,
}: AppleNativeConfigCardProps) => (
  <Card>
    <CardBody>
      <LabeledCheckbox
        checked={config.enabled}
        onChange={() => onChange({ ...config, enabled: !config.enabled })}
        label={label}
      />
      <FormTextInput
        label="Apple TEAM ID"
        classes={classes}
        name="appleNativeTeamId"
        value={config.teamId}
        handleChange={e => onChange({ ...config, teamId: e.target.value })}
      />
      <FormTextInput
        label="Apple SERVICE ID"
        classes={classes}
        name="appleNativeClientId"
        value={config.clientId}
        handleChange={e => onChange({ ...config, clientId: e.target.value })}
      />
      <FormTextInput
        label="Apple KEY FILE ID"
        classes={classes}
        name="appleNativeKeyFileId"
        value={config.keyFileId}
        handleChange={e => onChange({ ...config, keyFileId: e.target.value })}
      />
      <FormTextInput
        label="Apple KEY FILE CONTENT"
        classes={classes}
        name="appleNativeKeyFileContent"
        value={config.keyFileContent}
        handleChange={e =>
          onChange({ ...config, keyFileContent: e.target.value })
        }
        maxLength={1000}
        rows={6}
        multiline={true}
      />
    </CardBody>
  </Card>
);

export default AppleNativeConfigCard;
